"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwPillTriggerField = _interopRequireDefault(require("../cwpilltriggerfield/CwPillTriggerField"));

var _CwPill = _interopRequireDefault(require("../cwpill/CwPill"));

var _CwMultiPicker = _interopRequireDefault(require("./CwMultiPicker.scss"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var CwMultiPicker =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwMultiPicker, _React$Component);

  function CwMultiPicker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwMultiPicker);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwMultiPicker).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPills", function (value) {
      var pills = [];

      if (value) {
        value.forEach(function (val) {
          if (!pills.some(function (p) {
            return p.key === val;
          })) {
            pills.push(_react.default.createElement(_CwPill.default, {
              id: val,
              key: val,
              value: val,
              deletePillIcon: _this.props.deletePillIcon,
              onDeletePill: _this.closePill
            }));
          }
        });
      }

      _this.setState({
        pills: pills
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addPill", function () {
      var text = _this.state.displayText;

      if (!text || text.match(/^ *$/)) {
        return;
      }

      if (!_this.props.allowCustomEntry || _this.props.validate && !_this.props.validate(text)) {
        _this.handlePicker(text);

        return;
      }

      var value = _this.props.value;

      if (text && !value.includes(text)) {
        value.push(text);
      }

      _this.props.onChange(value);

      _this.setState({
        displayText: ''
      });

      _this.focus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focus", function () {
      if (_this.cwPillTriggerField) {
        _this.cwPillTriggerField.focus();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (displayText) {
      _this.setState({
        displayText: displayText
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closePill", function (key) {
      var values = _this.props.value;
      values = values.filter(function (v) {
        return v !== key.id;
      });

      _this.props.onChange(values);

      _this.focus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handlePicker", function () {
      if (_this.props.disabled) {
        return;
      }

      if (_this.props.onPicker) {
        _this.props.onPicker(_this.state.displayText);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getStyle", function () {
      if (_this.props.invalid) {
        return _CwMultiPicker.default.cwMultiSelectStyleInvalid;
      } else if (_this.props.disabled) {
        return _CwMultiPicker.default.cwMultiSelectStyleDisabled;
      } else {
        return _this.state.focused ? _CwMultiPicker.default.cwMultiSelectStyleFocused : _CwMultiPicker.default.cwMultiSelectStyle;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onKeyDown", function (event) {
      if (event.key === 'Enter' || event.key === 'Tab') {
        _this.addPill();

        event.preventDefault();
      } else if (event.key === 'Backspace') {
        var values = _this.props.value;

        if (_this.state.displayText === '') {
          values.pop();

          _this.props.onChange(values);
        }
      }
    });
    _this.state = {
      displayText: '',
      pills: []
    };
    return _this;
  }

  (0, _createClass2.default)(CwMultiPicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value !== prevProps.value) {
        this.getPills(this.props.value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement(_CwPillTriggerField.default, (0, _extends2.default)({}, this.props, {
        style: this.getStyle(),
        ref: function ref(input) {
          return _this2.cwPillTriggerField = input;
        },
        pills: this.state.pills,
        value: this.state.displayText,
        onBlur: this.addPill,
        onChange: this.onChange,
        handleTriggerClick: this.handlePicker,
        onKeyDown: this.onKeyDown
      }));
    }
  }]);
  return CwMultiPicker;
}(_react.default.Component);

CwMultiPicker.propTypes = _objectSpread({}, _CwPillTriggerField.default.propTypes, {
  /**
   * List of strings to display as pills
   */
  value: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),

  /**
   * Function to check if the input text is a valid item
   * Should return true if the value is valid
   */
  validate: _propTypes.default.func,

  /**
   * Indicates whether custom text can be input as a pill
   */
  allowCustomEntry: _propTypes.default.bool,

  /**
   * Callback function that is fired when picker is clicked
   */
  onPicker: _propTypes.default.func
});
CwMultiPicker.defaultProps = {
  value: []
};
var _default = CwMultiPicker;
exports.default = _default;